export default __webpack_public_path__ + "static/media/place-2.4ed02c62.png";